window.ko = require('knockout');
